/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/


import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Aboutus from '../../../components/Views/public/aboutus' 
 

class AboutusPage extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);

    }
    render() {
        return (
            <> 
                <Aboutus /> 
            </>
        )
    }
}

AboutusPage.propTypes = {
    classes: PropTypes.object.isRequired,
}

function mapStateToProps() {
    return {}
}

const styledAboutusPage = AboutusPage
const connectedAboutusPage = connect(mapStateToProps)(styledAboutusPage)
export { connectedAboutusPage as AboutusPage }
